<template lang="pug">
.login--content
  .content__left
    .middle
      h1.title.is-1 Bienvenido
      h2.subtitle.is-2 al gestor de cotizaciones
      .benefits__text
        span Con este sistema podrás:
        ul
          li Crear una cotización
          li Seguir una cotización
  .content__right
      .password-policies-wrapper
          .title-update-password Actualiza Contraseña
          .subtitle-update-password Para comenzar, por favor, actualiza tu contraseña por una que puedas recordar con facilidad. 
          password-policies(
            @changeReNewPassword="handleReNewPassword"
            @changeNewPassword="handleNewPassword"
            @isCheckboxesComplete="handleCheckboxesComplete"
            @newPasswordValue="getNewPasswordValue"
            @getReNewPassword="reNewPasswordValue"
          )
          .button-wrapper
            button.primary-button-xs( @click="updatePassword", :disabled="buttonDisabled") Actualizar
  modal-change-password-success(typeManagerPassword= "actualizado")
</template>

<script>
import PasswordPolicies from '../components/PasswordPolicies';
import PasswordRepository from '../services/PasswordRepository';
import ModalChangePasswordSuccess from '../views/modals/changePasswordSuccess';

export default {
    components: { PasswordPolicies, ModalChangePasswordSuccess},
    data() {
      return {
        buttonDisabled: true,
        newPassword: "",
        reNewPassword: "",
        matchPasswords: false,
        checkboxesComplete: false,
      }
    },

    methods: {
      updatePassword() {
        const body = {
            new_password1: this.newPassword,
            new_password2: this.reNewPassword,
        }
        PasswordRepository.updatePasswordFirstTime(body).then((result) => {
          this.$modal.show('modal-change-password-success');
        }).catch( (error) => {
          console.log("ERROR", error)
        })
      },

      handleReNewPassword(passwordsMatch) {
        this.matchPasswords = passwordsMatch
        this.isButtonActive()
      },

      handleNewPassword(passwordsMatch) {
        this.matchPasswords = passwordsMatch
        this.isButtonActive()
      },

      handleCheckboxesComplete(checkboxesComplete) {
        this.checkboxesComplete = checkboxesComplete
        this.isButtonActive()
      },

      getNewPasswordValue(newPasswordValue) {
        this.newPassword = newPasswordValue
      },

      reNewPasswordValue(reNewPassword) {
        this.reNewPassword = reNewPassword
      },

      isButtonActive() {
      this.buttonDisabled = !(this.matchPasswords && this.checkboxesComplete)
    },
    }
}
</script>

<style lang="scss" scoped>
@import "~bulma/sass/utilities/mixins";
@import '../assets/scss/variables.scss';

.login--content {
  display: flex;
  height: 100vh;

  .content__left {
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    background-image: url('../assets/images/login-bg.jpg');
    background-color: white;
    width: 100%;
    max-width: 720px;
    background-repeat: no-repeat;
    background-position: center right;
    text-align: left;

    @include desktop {
      display: flex;
    }

    .middle {
      width: 100%;
      max-width: 580px;
      margin-right: 2.5em;

      h1 {
        color: white;
        font-weight: 100;
      }
      h2 {
        color: white;
        font-weight: 100;
      }

      .benefits__text{
        margin-top: 3.5em;
        color: white;

        span{
          display: block;
          font-weight: bold;
          font-size: 1.5em;
          margin-bottom: 1em;
        }

        ul{
          margin-left: 1.3em;

          li {
            font-weight: 100;
            font-size: 1.5em;
            list-style-type: disc;
          }
        }
      }
    }
  }

  .content__right {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .middle {
      width: 360px;
      margin: 0 auto;

      form {
        display: flex;
        flex-direction: column;
      }
      .logo{
        margin-bottom: 1.5em;
        text-align: center;
        img{
          width: 50%;
          margin: 0 auto;
        }
      }
      .help__text{
        color: #ABABAB;
        text-align: center;
        font-size: 1em;
      }

      .field{
        margin-bottom: 2em;
        text-align: left;
        &.big-margin{
          margin-top: 2em;
          margin-bottom: 1em;
        }

        span{
          font-size: 1.375em;
          color: #878787;
          font-weight: 100;
        }

        input {
          width: 100%;
          max-width: 320px;
          padding: 0.5em 0;
          border: none;
          border-bottom: 1px solid #ABABAB;
          font-family: 'mirai-bold_font';
          color: #595959;
          font-size: 1.375em;

          &.field__error{
            border-bottom: 1px solid #FF6D46;
          }
        }

        .button {
          color: white;
          border-radius: 25px;
          font-size: 1.125em;
          background-color: #FF6D46;
          width:187px;

          &:hover{
            background-color: #F45327;
          }
        }

        &.center{
          text-align: center;
        }
      }
    }
  }
  .password-policies-wrapper {
      max-width: 381px;
  }
  .title-update-password {
    font-size: 24px;
    font-weight: bold;
    color: $primary;
    text-align: center;
    margin-bottom: 40px;
  }
  .subtitle-update-password {
    font-size: 16px;
    text-align: left;
    margin-bottom: 32px;
  }
  .button-wrapper {
    display: flex;
    justify-content: center;
  }
}
</style>